import { TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";
import { RootState, RootDispatch } from "./index";

export const useRootSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useRootDispatch = () => useDispatch<RootDispatch>();
